export function initGlobal() {
  function clamp(n, min, max) {
    return Math.max(min, Math.min(n, max));
  }

  function scrollItemStart(container, item, { behavior = 'smooth' } = {}) {
    const cRect = container.getBoundingClientRect();
    const iRect = item.getBoundingClientRect();
    const current = container.scrollLeft;

    const itemLeft = iRect.left - cRect.left + current;
    const maxScroll = container.scrollWidth - container.clientWidth;

    const target = clamp(itemLeft, 0, maxScroll);
    container.scrollTo({ left: target, behavior });
    setTimeout(() => {
      container.style.opacity = '1';
    }, 100);
  }

  function initSnapNav() {
    const container = document.querySelector('.snap-wrapper[data-snap-nav]');
    if (!container) return;
    container.style.opacity = '0';
    const active = container.querySelector(
      ".snap-item.is-active, .snap-item[aria-current='page']"
    );
    if (!active) {
      container.style.opacity = '1';
      return;
    }

    // 처음 로드에서는 부드러운 스크롤이 튀는 느낌이면 auto 추천
    scrollItemStart(container, active, { behavior: 'auto', edgePadding: 0 });
  }

  if (document.readyState === 'loading') {
    window.addEventListener('DOMContentLoaded', initSnapNav, { once: true });
    return;
  }

  requestAnimationFrame(() => {
    initSnapNav();
  });
}
